import styled from '@emotion/styled';

export const Container = styled.div`
  margin: ${({ theme }) => theme.spacing(32, 0, 48)};
  display: flex;
  gap: ${({ theme }) => theme.spacing(64)};
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    flex-direction: column;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    gap: ${({ theme }) => theme.spacing(32)};
  }
`;

export const MainContent = styled.div`
  margin-bottom: 120px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-basis: 66%;
  }
`;

export const MainContentHalfWidth = styled.div`
  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-basis: 50%;
  }
`;

export const MainContentFullWidth = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-basis: 100%;
  }
`;

export const Sidebar = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-basis: 33%;
  }
  ${({ theme }) => theme.breakpoints.down('xs')} {
    order: -1;
  }
`;

export const SidebarHalfWidth = styled.div`
  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-basis: 50%;
  }
  ${({ theme }) => theme.breakpoints.down('xs')} {
    order: -1;
  }
`;
